// icons
import { MdWarehouse, MdInventory, MdHistory, MdList, MdCompareArrows } from "react-icons/md";

const almacen = {
  id: 'almacen-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'almacen',
      title: "Almacén",
      type: 'collapse',
      icon: MdWarehouse,
      children: [
        {
          id: 'catalogo-insumos',
          title: "Catálogo de Insumos",
          type: 'item',
          breadcrumbs: false,
          icon: MdList,
          url: '/almacen/catalogo-insumos'
        },
        {
          id: 'existencias',
          title: "Existencias",
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory,
          url: '/almacen/existencias'
        },
        {
          id: 'transferencia-tecnicos',
          title: "Transferencia Técnicos",
          type: 'item',
          breadcrumbs: false,
          icon: MdCompareArrows,
          url: '/almacen/transferencia-tecnicos'
        },
        {
          id: 'bitacora-movimientos',
          title: "Bitácora de Movimientos",
          type: 'item',
          breadcrumbs: false,
          icon: MdHistory,
          url: '/almacen/bitacora-movimientos'
        },
        
      ]
    }
  ]
};

export default almacen;
